module.exports = __webpack_public_path__ + "img/bess_item-v2.38f3552f.svg";